import { Routes, mapToCanActivate } from '@angular/router';
import { CustomerLocationGuard } from '@next/core-lib/relationships';

import { redirectToBemAdviceGuard } from '../shared/guards/redirect-to-bem-advice.guard';
import { DashboardComponent } from './dashboard.component';

export const dashboardRoutes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    canActivate: mapToCanActivate([CustomerLocationGuard]),
  },
  {
    path: 'bem',
    component: DashboardComponent,
    canActivate: [...mapToCanActivate([CustomerLocationGuard]), redirectToBemAdviceGuard],
  },
];
